/**
 * Links that leave the site, routed through the server so the click can be counted.
 *
 * The site is measured server-side and cookie-free (no analytics script, no consent banner), which
 * means a click on "Køb billet" — the one number the festival actually wants — is invisible unless
 * it passes through the server on the way out. `/ud/billetter` logs the event and answers 302 to
 * the storefront.
 *
 * Only the production build turns this on: staging is served from Blob Storage, which has no server
 * to answer that path, so there the buttons keep pointing straight at the shop.
 */

/** The server route that counts the click and forwards to the ticket shop. */
export const TICKETS_OUT_PATH = '/ud/billetter';

const TRACKING_ENABLED = import.meta.env.VITE_OUTBOUND_TRACKING === 'true';

/**
 * The href a buy button should use: the measured route when there is a storefront to forward to,
 * and otherwise whatever was passed — including `undefined`, which leaves the caller's own
 * on-page-anchor fallback in charge.
 */
export function ticketShopHref(url: string | undefined): string | undefined {
  if (!url) return url;
  return TRACKING_ENABLED ? TICKETS_OUT_PATH : url;
}
